import request from "@/utils/request";
import { apiConfig } from "../config/api";

// 用户信息分页列表
export function getUserPager(req) {
  return request({
    url: apiConfig.userInfo.api.pager.url,
    method: "post",
    data: req
  });
}

// 用户信息分页列表搜索功能
export function searchUserPager(req) {
  return request({
    url: apiConfig.userInfo.api.searchPager.url,
    method: "post",
    data: req
  });
}
// 用户信息分页列表搜索功能
export function getUserList(req) {
  return request({
    url: apiConfig.userInfo.api.getUserList.url,
    method: "get",
    params: {
      username: req
    }
  });
}
// 查询用户信息
export function findUser(id) {
  return request({
    url: apiConfig.userInfo.api.find.url,
    method: "get",
    params: {
      userId: id
    }
  });
}
// 新增用户信息
export function addUser(req) {
  return request({
    url: apiConfig.userInfo.api.add.url,
    method: "post",
    data: req
  });
}
// 更新用户信息
export function updateUser(userId, req) {
  return request({
    url: apiConfig.userInfo.api.update.url,
    method: "post",
    params: {
      userId: userId
    },
    data: req
  });
}
// 删除用户信息
export function deleteUser(userIds) {
  return request({
    url: apiConfig.userInfo.api.delete.url,
    method: "post",
    data: userIds
  });
}
// 审核用户信息
export function auditUser(userId, req) {
  return request({
    url: apiConfig.userInfo.api.audit.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      baseInfoAuditStatus: req.baseInfoAuditStatus
    }
  });
}
// 下载导入证件照错误信息
export function exportIdPhotoError() {
  return request({
    url: apiConfig.userInfo.api.importIdPhoto.url.exportError,
    method: "get",
    responseType: "blob"
  });
}
// 下载导入用户错误信息
export function exportUserInfoError() {
  return request({
    url: apiConfig.userInfo.api.importUserInfo.url.exportError,
    method: "get",
    responseType: "blob"
  });
}
// 导出个人信息
export function exportUserList(searchForm) {
  return request({
    url: apiConfig.userInfo.api.exportUserList.url,
    method: "post",
    data: searchForm,
    responseType: "blob"
  });
}
// 导出证件照
export function exportIdPhoto(searchForm) {
  return request({
    url: apiConfig.userInfo.api.exportIdPhoto.url,
    method: "post",
    data: searchForm,
    responseType: "blob"
  });
}

// 查询用户简历信息
export function findUserResumeInfo(id) {
  return request({
    url: apiConfig.userResumeInfo.api.findResume.url,
    method: "get",
    params: {
      userId: id
    }
  });
}
export function mergeAccount(userId, mphone) {
  return request({
    url: apiConfig.userInfo.api.mergeAccount.url,
    method: "post",
    params: {
      userId: userId,
      mphone: mphone
    }
  });
}

// 保存用户简历信息
export function updateUserResumeInfo(req) {
  return request({
    url: apiConfig.userResumeInfo.api.update.url,
    method: "post",
    params: {
      userId: req.userId
    },
    data: {
      id: req.id,
      sex: req.sex,
      birthday: req.birthday,
      nationality: req.nationality,
      politicalStatus: req.politicalStatus,
      email: req.email,
      address: req.address,
      education: req.education,
      major: req.major,
      graduateSchool: req.graduateSchool
    }
  });
}
// 获取荣誉列表
export function getResumeHonourList(userId) {
  return request({
    url: apiConfig.userResumeInfo.api.getResumeHonourList.url,
    method: "get",
    params: {
      userId: userId
    }
  });
}

// 获取荣誉
export function findResumeHonour(id) {
  return request({
    url: apiConfig.userResumeInfo.api.findResumeHonour.url,
    method: "get",
    params: {
      id: id
    }
  });
}

// 新增荣誉
export function addResumeHonour(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.addResumeHonour.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      certificateName: req.certificateName,
      issuedBy: req.issuedBy,
      winningTime: req.winningTime,
      uploadCertificate: req.uploadCertificate
    }
  });
}

// 更新荣誉
export function updateResumeHonour(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.updateResumeHonour.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      id: req.id,
      certificateName: req.certificateName,
      issuedBy: req.issuedBy,
      winningTime: req.winningTime,
      uploadCertificate: req.uploadCertificate
    }
  });
}

// 删除荣誉
export function deleteResumeHonour(id) {
  return request({
    url: apiConfig.userResumeInfo.api.deleteResumeHonour.url,
    method: "post",
    params: {
      id: id
    }
  });
}
// 获取证书列表
export function getResumeCertificateList(userId) {
  return request({
    url: apiConfig.userResumeInfo.api.getResumeCertificateList.url,
    method: "get",
    params: {
      userId: userId
    }
  });
}

// 获取证书
export function findResumeCertificate(id) {
  return request({
    url: apiConfig.userResumeInfo.api.findResumeCertificate.url,
    method: "get",
    params: {
      id: id
    }
  });
}

// 新增证书
export function addResumeCertificate(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.addResumeCertificate.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      certificateName: req.certificateName,
      issuedBy: req.issuedBy,
      winningTime: req.winningTime,
      uploadCertificate: req.uploadCertificate
    }
  });
}

// 更新证书
export function updateResumeCertificate(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.updateResumeCertificate.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      id: req.id,
      certificateName: req.certificateName,
      issuedBy: req.issuedBy,
      winningTime: req.winningTime,
      uploadCertificate: req.uploadCertificate
    }
  });
}

// 删除证书
export function deleteResumeCertificate(id) {
  return request({
    url: apiConfig.userResumeInfo.api.deleteResumeCertificate.url,
    method: "post",
    params: {
      id: id
    }
  });
}

// 获取教育经历列表
export function getResumeEducationList(userId) {
  return request({
    url: apiConfig.userResumeInfo.api.getResumeEducationList.url,
    method: "get",
    params: {
      userId: userId
    }
  });
}

// 获取教育经历证书
export function findResumeEducation(id) {
  return request({
    url: apiConfig.userResumeInfo.api.findResumeEducation.url,
    method: "get",
    params: {
      id: id
    }
  });
}

// 新增教育经历证书
export function addResumeEducation(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.addResumeEducation.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      endTime: req.endTime,
      school: req.school,
      major: req.major,
      education: req.education,
      serve: req.serve,
      uploadEducationAnnex: req.uploadEducationAnnex
    }
  });
}

// 更新教育经历证书
export function updateResumeEducation(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.updateResumeEducation.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      id: req.id,
      endTime: req.endTime,
      school: req.school,
      major: req.major,
      education: req.education,
      serve: req.serve,
      uploadEducationAnnex: req.uploadEducationAnnex
    }
  });
}

// 删除教育经历证书
export function deleteResumeEducation(id) {
  return request({
    url: apiConfig.userResumeInfo.api.deleteResumeEducation.url,
    method: "post",
    params: {
      id: id
    }
  });
}

// 获取实习经历列表
export function getResumeInternshipList(userId) {
  return request({
    url: apiConfig.userResumeInfo.api.getResumeInternshipList.url,
    method: "get",
    params: {
      userId: userId
    }
  });
}

// 获取实习经历
export function findResumeInternship(id) {
  return request({
    url: apiConfig.userResumeInfo.api.findResumeInternship.url,
    method: "get",
    params: {
      id: id
    }
  });
}
// 新增实习经历
export function addResumeInternship(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.addResumeInternship.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      companyName: req.companyName,
      startTime: req.startTime,
      endTime: req.endTime,
      position: req.position,
      workContent: req.workContent
    }
  });
}
// 更新实习经历
export function updateResumeInternship(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.updateResumeInternship.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      id: req.id,
      companyName: req.companyName,
      startTime: req.startTime,
      endTime: req.endTime,
      position: req.position,
      workContent: req.workContent
    }
  });
}
// 删除实习经历
export function deleteResumeInternship(id) {
  return request({
    url: apiConfig.userResumeInfo.api.deleteResumeInternship.url,
    method: "post",
    params: {
      id: id
    }
  });
}
// 获取项目经历列表
export function getResumeProjectList(userId) {
  return request({
    url: apiConfig.userResumeInfo.api.getResumeProjectList.url,
    method: "get",
    params: {
      userId: userId
    }
  });
}
// 获取项目经历
export function findResumeProject(id) {
  return request({
    url: apiConfig.userResumeInfo.api.findResumeProject.url,
    method: "get",
    params: {
      id: id
    }
  });
}
// 新增项目经历
export function addResumeProject(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.addResumeProject.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      projectName: req.projectName,
      startTime: req.startTime,
      endTime: req.endTime,
      projectResult: req.projectResult,
      projectDuty: req.projectDuty
    }
  });
}
// 更新项目经历
export function updateResumeProject(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.updateResumeProject.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      id: req.id,
      projectName: req.projectName,
      startTime: req.startTime,
      endTime: req.endTime,
      projectResult: req.projectResult,
      projectDuty: req.projectDuty
    }
  });
}
// 删除项目经历
export function deleteResumeProject(id) {
  return request({
    url: apiConfig.userResumeInfo.api.deleteResumeProject.url,
    method: "post",
    params: {
      id: id
    }
  });
}
// 获取培训经历列表
export function getResumeTrainingList(userId) {
  return request({
    url: apiConfig.userResumeInfo.api.getResumeTrainingList.url,
    method: "get",
    params: {
      userId: userId
    }
  });
}
// 获取培训经历
export function findResumeTraining(id) {
  return request({
    url: apiConfig.userResumeInfo.api.findResumeTraining.url,
    method: "get",
    params: {
      id: id
    }
  });
}
// 新增培训经历
export function addResumeTraining(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.addResumeTraining.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      trainingCompany: req.trainingCompany,
      startTime: req.startTime,
      endTime: req.endTime,
      trainingContent: req.trainingContent,
      achievements: req.achievements,
      uploadProof: req.uploadProof
    }
  });
}
// 更新培训经历
export function updateResumeTraining(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.updateResumeTraining.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      id: req.id,
      trainingCompany: req.trainingCompany,
      startTime: req.startTime,
      endTime: req.endTime,
      trainingContent: req.trainingContent,
      achievements: req.achievements,
      uploadCertificate: req.uploadCertificate
    }
  });
}
// 删除培训经历
export function deleteResumeTraining(id) {
  return request({
    url: apiConfig.userResumeInfo.api.deleteResumeTraining.url,
    method: "post",
    params: {
      id: id
    }
  });
}
// 获取工作经历列表
export function getResumeWorkList(userId) {
  return request({
    url: apiConfig.userResumeInfo.api.getResumeWorkList.url,
    method: "get",
    params: {
      userId: userId
    }
  });
}
// 获取工作经历
export function findResumeWork(id) {
  return request({
    url: apiConfig.userResumeInfo.api.findResumeWork.url,
    method: "get",
    params: {
      id: id
    }
  });
}
// 新增工作经历
export function addResumeWork(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.addResumeWork.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      companyName: req.companyName,
      startTime: req.startTime,
      endTime: req.endTime,
      position: req.position,
      workContent: req.workContent
    }
  });
}
// 更新工作经历
export function updateResumeWork(userId, req) {
  return request({
    url: apiConfig.userResumeInfo.api.updateResumeWork.url,
    method: "post",
    params: {
      userId: userId
    },
    data: {
      id: req.id,
      companyName: req.companyName,
      startTime: req.startTime,
      endTime: req.endTime,
      position: req.position,
      workContent: req.workContent
    }
  });
}
// 删除工作经历
export function deleteResumeWork(id) {
  return request({
    url: apiConfig.userResumeInfo.api.deleteResumeWork.url,
    method: "post",
    params: {
      id: id
    }
  });
}

// 用户分析
export function userAnalyse() {
  return request({
    url: apiConfig.userInfo.api.userAnalyse.url,
    method: "get"
  });
}

// 用户数量分析
export function userCountAnalyse(req) {
  return request({
    url: apiConfig.userInfo.api.userCountAnalyse.url,
    method: "get",
    params: {
      startDate: req[0],
      endDate: req[1]
    }
  });
}
// 用户增长分析
export function userGrowAnalyse(req) {
  return request({
    url: apiConfig.userInfo.api.userGrowAnalyse.url,
    method: "get",
    params: {
      startDate: req[0],
      endDate: req[1]
    }
  });
}
// 1类证书用户分析
export function userCerAnalyse() {
  return request({
    url: apiConfig.userInfo.api.userCerAnalyse.url,
    method: "get"
  });
}
// 1类证书用户数量分析
export function userCerCountAnalyse(req) {
  return request({
    url: apiConfig.userInfo.api.userCerCountAnalyse.url,
    method: "get",
    params: {
      startDate: req[0],
      endDate: req[1]
    }
  });
}
// 1类证书用户增长分析
export function userCerGrowAnalyse(req) {
  return request({
    url: apiConfig.userInfo.api.userCerGrowAnalyse.url,
    method: "get",
    params: {
      startDate: req[0],
      endDate: req[1]
    }
  });
}
// 2类证书用户分析
export function userPaperCerAnalyse() {
  return request({
    url: apiConfig.userInfo.api.userPaperCerAnalyse.url,
    method: "get"
  });
}
// 2类证书用户数量分析
export function userPaperCerCountAnalyse(req) {
  return request({
    url: apiConfig.userInfo.api.userPaperCerCountAnalyse.url,
    method: "get",
    params: {
      startDate: req[0],
      endDate: req[1]
    }
  });
}
// 2类证书用户增长分析
export function userPaperCerGrowAnalyse(req) {
  return request({
    url: apiConfig.userInfo.api.userPaperCerGrowAnalyse.url,
    method: "get",
    params: {
      startDate: req[0],
      endDate: req[1]
    }
  });
}

// 绑定用户项目
export function bindUserProject(userIds, projectIds) {
  return request({
    url: apiConfig.userInfo.api.bindUserProject.url,
    method: "post",
    data: userIds,
    params: {
      projectIds: projectIds
    }
  });
}

// 查询字典
export function getAllMapListMetaData() {
  return request({
    url: apiConfig.userInfo.api.getAllMapListMetaData.url,
    method: "get"
  });
}
// 发送短信
export function sendMessage(req) {
  return request({
    url: apiConfig.userInfo.api.sendMessage.url,
    method: "post",
    data: req
  });
}
// 发送短信预览
export function sendMessagePreview(req) {
  return request({
    url: apiConfig.userInfo.api.sendMessagePreview.url,
    method: "post",
    data: req
  });
}
